export { SORT_TYPES } from './sortTypes';

export const OUTSTANDING_PLEDGES_COLUMNS = [
  { id: 'pledge_number', label: 'Pledge #', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'donor_name', label: 'Donor', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'fund_name', label: 'Fund', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'campaign_name', label: 'Campaign', defaultVisible: false, sortable: false },
  { id: 'status', label: 'Status', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'total_amount', label: 'Pledged', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'outstanding_amount', label: 'Outstanding', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'overdue_amount', label: 'Overdue', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'next_due_date', label: 'Next Payment Due', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'days_overdue', label: 'Days Overdue', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'expected_fulfillment_date', label: 'Expected Fulfillment', defaultVisible: false, sortable: true, sortType: 'date' },
  { id: 'pledge_date', label: 'Pledge Date', defaultVisible: false, sortable: true, sortType: 'date' },
];

export const getDefaultVisibleColumns = () =>
  OUTSTANDING_PLEDGES_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  OUTSTANDING_PLEDGES_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
